import handleVideoPlayer from '@/javascript/new_site/modules/handleVideoPlayer'
import showSideBarSection from '@/javascript/new_site/modules/showSidebarSection'
const filterVideos = () => {
  $('.filter-button').click(function () {
    $('.filter-button--active').removeClass('filter-button--active')

    $(this).addClass('filter-button--active')

    const class__hidden_video = 'card__videos--hidden-video'

    $(`.${class__hidden_video}`).removeClass(class__hidden_video)

    const category = $(this).data('button-category')
    const videos = $('.card__videos').filter(function () {
      const video = $(this).data('category')
      return !video.toString().match(category) && category !== 'all'
    })

    $(videos).addClass(class__hidden_video)
  })
}

const carousel = () => {
  const counter = (event) => {
    const videoId = $(
      `.modal-portfolio__video__wrapper:eq(${event.item.index})`
    ).data('video-url')
    showSideBarSection(videoId)

    const url = window.location.href.split('/')
    const deleteId = url.slice(0, -1)

    const newUrl = deleteId.join('/') + '/' + videoId
    changeURL(newUrl)
    handleVideoPlayer(event.item.index)
  }

  const carousel_video = $(
    '.modal-portfolio__carousel__owl-slider'
  ).owlCarousel({
    items: 1,
    loop: false,
    dots: false,
    onTranslate: counter,
  })

  $('.slide-control.arrow-left').click(() => {
    carousel_video.trigger('prev.owl.carousel')
  })
  $('.slide-control.arrow-right').click(() => {
    carousel_video.trigger('next.owl.carousel')
  })
}

const getVideoIndex = (url) => {
  let indexVideo = 0
  $('.modal-portfolio__video__wrapper').each((index, item) => {
    if ($(item).data('video-url') === url) {
      indexVideo = index
    }
  })
  return indexVideo
}

const changeURL = (url) => {
  window.history.pushState('Object', 'Categoria JavaScript', url)
}

const handleURL = () => {
  $('.__handle-url').click(function (e) {
    e.preventDefault()
    const url = $(this).attr('href')
    const videoURL = url.split('/')
    const videoId = videoURL[videoURL.length - 1]
    const videoIndex = getVideoIndex(videoId)

    $('.modal-portfolio__carousel__owl-slider').trigger(
      'to.owl.carousel',
      videoIndex
    )

    showSideBarSection(videoId)

    changeURL(url)

    handleVideoPlayer(videoIndex)
    return
  })
}

const filterCategoriesHome = () => {
  $('.filter-home-button').click(function () {
    $('.filter-home-button.active').removeClass('active')

    $(this).addClass('active')

    const category = $(this).data('home-button')

    $('.category-home')
      .stop()
      .fadeOut(() => {
        $(`.category-home[data-home-category=${category}`).stop().fadeIn()
      })
  })
}

const scrollbarVisible = () => {
  let wrapper = $('.modal-portfolio__side-bar__description.section-separator')

  $(wrapper).each(function (index, item) {
    const parent_height = $(this)
    .find('.modal-portfolio__side-bar__description__text')
    .html()
    const text_size = parent_height?parent_height.length:0

    if (text_size < 500) {
      $(this).find('.read-more').css('display', 'none')
    }
  })}

const readMoreLess = () => {
  let defaultHeight = 90
  let button = $('.read-more')

  button.on('click', function () {
    let newHeight = 0

    let text = $(
      '.modal-portfolio__side-bar__wrapper.active .modal-portfolio__side-bar__description__text'
    )
    let textHeight = text.find('p').css('height')
    text.css({ 'max-height': defaultHeight, overflow: 'hidden' })

    textHeight = textHeight ? parseInt(textHeight.replace('px', '')) : 100

    if (text.hasClass('active')) {
      newHeight = defaultHeight
      text.removeClass('active')
      button.text('ver mais')
    } else {
      newHeight = textHeight + 30
      text.addClass('active')
      button.text('ver menos')
    }
    text.stop(true, true).animate(
      {
        height: newHeight,
        'max-height': newHeight,
      },
      500
    )
  })
}

const checkUrl = () => {
  let pathname = window.location.pathname
  if(pathname.match(new RegExp('/', 'g')).length === 3) {
    $(`a[href="${pathname}"]`).click()
  }
}

const modalVideoPassword = () => {
  $('#video_password').on('input', (e) => {
    if (e.target.value.length) {
      $('#video-password-button').removeAttr('disabled')
    } else {
      $('#video-password-button').attr('disabled', 'disabled')
    }
  })
}

const MyPage = () => {
  handleURL()

  $('.open-modal-portfolio').click(() => {
    $('.modal-portfolio')
    .stop()
    .fadeIn(function () {})
  })

  $('.modal-portfolio__close').click(() => {
    $('.modal-portfolio').stop().fadeOut()
    handleVideoPlayer()
    let parts = window.location.pathname.split('/')
    parts.pop() // remove last element (video id)
    window.history.pushState('', '', `${parts.join('/')}`)
  })

  filterCategoriesHome()
  filterVideos()
  readMoreLess()
  carousel()
  checkUrl()

  $(document).ready(() => {
    scrollbarVisible()
    setTimeout(() => modalVideoPassword(), 200)
  })

  log("MY PAGE")
}

export default MyPage
